/* Manifold shop — shared pre-order box logic (works for both V1 and V2 pages) */
(function () {
  const money = (n) => '$' + (n % 1 === 0 ? n : n.toFixed(2));
  // Cutoff may be epoch SECONDS (dynamic rolling slots) or a legacy ISO string; return ms.
  function cutoffMs(c) { if (c == null || c === '') return NaN; const n = Number(c); return isFinite(n) ? n * 1000 : new Date(c).getTime(); }
  const STORE = 'ml-box-v1';
  const state = { box: {}, day: null, win: null, first: '', last: '', phone: '', clicked: {} };
  const catalog = {};

  document.querySelectorAll('[data-price]').forEach((el) => {
    catalog[el.dataset.id] = { name: el.dataset.name, price: Number(el.dataset.price), cat: el.dataset.cat || null };
  });
  // Merge a page-provided catalog (cart page / PDP) so rows can render where the item cards aren't present
  if (Array.isArray(window.ML_CATALOG)) {
    window.ML_CATALOG.forEach((c) => {
      const prev = catalog[c.id] || {};
      catalog[c.id] = { name: c.name || prev.name, price: Number(c.price != null ? c.price : prev.price), cat: c.cat || prev.cat || null, img: c.img || prev.img || null, url: c.url || prev.url || ('/products/' + c.id), sub: c.sub || prev.sub || null };
    });
  }

  // Persist the box across pages (shop sidebar, /cart, PDP) — preview only, no server cart
  function loadState() {
    try {
      const raw = localStorage.getItem(STORE);
      if (!raw) return;
      const d = JSON.parse(raw);
      if (d && typeof d === 'object') {
        state.box = d.box && typeof d.box === 'object' ? d.box : {};
        state.day = d.day || null;
        state.date = d.date || null;
        state.cutoff = d.cutoff || null;
        state.first = d.first || '';
        state.last = d.last || '';
        state.phone = d.phone || '';
        state.clicked = d.clicked && typeof d.clicked === 'object' ? d.clicked : {};
      }
    } catch (e) { /* ignore */ }
  }
  function saveState() {
    try { localStorage.setItem(STORE, JSON.stringify({ box: state.box, day: state.day, date: state.date, cutoff: state.cutoff, first: state.first, last: state.last, phone: state.phone, clicked: state.clicked })); } catch (e) { /* ignore */ }
  }
  loadState();

  const $box = document.getElementById('box-items');
  const $scroll = document.querySelector('.box__scroll');
  const $empty = document.getElementById('box-empty');
  const $subtotal = document.getElementById('box-subtotal');
  const $count = document.querySelectorAll('.js-count');
  const $pickup = document.getElementById('box-pickup');
  const $reserve = document.getElementById('reserve');
  const $note = document.getElementById('box-note');
  const $live = document.getElementById('box-live');
  const $boxhint = document.getElementById('box-boxhint');
  const $overlimit = document.getElementById('box-overlimit');

  // Bakers' Box recipes — from window.ML_BOXES (rendered on every box page), with the page's own
  // combo buttons merged in as a fallback. Used to hint when a selection forms a known box and to
  // stamp which box(es) an order contains at checkout.
  const BOXES = [];
  function addBox(name, combo) {
    if (!name || !combo || !Object.keys(combo).length) return;
    if (BOXES.some((b) => b.name === name)) return;
    BOXES.push({ name: name, combo: combo, size: Object.values(combo).reduce((a, b) => a + b, 0) });
  }
  if (Array.isArray(window.ML_BOXES)) window.ML_BOXES.forEach((b) => addBox(b.name, b.combo));
  document.querySelectorAll('.js-add-combo').forEach((el) => {
    let combo = {};
    try { combo = JSON.parse(el.getAttribute('data-combo') || '{}'); } catch (e) { combo = {}; }
    addBox(el.dataset.name, combo);
  });

  // Which named box(es) the current selection forms. `present` = selection contains a full copy of
  // the box (plus maybe extras); `exact` = selection IS exactly one box, nothing more.
  function detectBoxes(box) {
    const present = [];
    let exact = null;
    const selIds = Object.keys(box).filter((id) => box[id] > 0);
    BOXES.forEach((b) => {
      const ids = Object.keys(b.combo);
      let copies = Infinity;
      ids.forEach((id) => { copies = Math.min(copies, Math.floor((box[id] || 0) / b.combo[id])); });
      if (copies >= 1 && copies !== Infinity) {
        present.push({ name: b.name, copies: copies, size: b.size });
        if (!exact && selIds.length === ids.length && ids.every((id) => box[id] === b.combo[id])) exact = b.name;
      }
    });
    present.sort((a, b) => b.size - a.size); // biggest match leads the hint
    return { present: present, exact: exact };
  }

  function announce(msg) { if ($live) { $live.textContent = ''; setTimeout(() => { $live.textContent = msg; }, 30); } }
  function note(msg) { if ($note) $note.textContent = msg; }
  function focusEl(sel) { const el = document.querySelector(sel); if (el) { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); el.focus({ preventScroll: true }); } }
  // If the box/pickup is edited after a reservation, un-lock the button so it recomputes
  function resetReserve() { if ($reserve && $reserve.disabled) { $reserve.disabled = false; $reserve.classList.remove('is-ready'); note(''); } }

  function totalCount() {
    return Object.values(state.box).reduce((a, b) => a + b, 0);
  }

  // Drop box items that are no longer sellable (removed from the menu) so a ghost from an older
  // saved cart can't inflate the count or trip the over-limit warning. window.ML_VARIANTS is the
  // full sellable set on every box page; only prune when it's actually populated.
  function pruneUnsellable() {
    const v = window.ML_VARIANTS;
    if (!v || typeof v !== 'object' || !Object.keys(v).length) return;
    let changed = false;
    Object.keys(state.box).forEach((id) => { if (!(id in v)) { delete state.box[id]; changed = true; } });
    if (changed) saveState();
  }

  function render() {
    pruneUnsellable();
    // Expire a stale pickup choice so it can never reach checkout: clear it if its cutoff (6 AM the
    // day before pickup) has passed, or if that day is no longer offered (its slot dropped server-side).
    if (state.cutoff && Date.now() >= cutoffMs(state.cutoff)) {
      state.day = null; state.date = null; state.cutoff = null;
    }
    if (state.day && document.querySelector('.js-day') && !document.querySelector('.js-day[data-day="' + state.day + '"]')) {
      state.day = null; state.date = null; state.cutoff = null;
    }
    // ids = catalog-known items we can render rows for; count = the TRUE box total across the whole
    // site (a page like the PDP only knows its own product, so never let its catalog shrink the count)
    const ids = Object.keys(state.box).filter((id) => state.box[id] > 0 && catalog[id]);
    const subtotal = ids.reduce((a, id) => a + catalog[id].price * state.box[id], 0);
    const c = totalCount();

    $count.forEach((n) => (n.textContent = c));
    // Header Box link doubles as the checkout cue: gains a subtle filled state once it has items.
    document.querySelectorAll('.ml-nav .cart').forEach((n) => n.classList.toggle('cart--active', c > 0));
    saveState();

    // Sync the pickup-day chips to persisted state (matters after a page load / cross-page nav)
    document.querySelectorAll('.js-day').forEach((d) => {
      const on = d.dataset.day === state.day;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-pressed', String(on));
    });
    // Dynamic order-cutoff line under the day chips: the selected day's cutoff is 6 AM the day before.
    // Formatted in Pacific time so the weekday/date is correct regardless of the viewer's own timezone.
    const $dayCutoff = document.getElementById('day-cutoff');
    if ($dayCutoff) {
      let cutLabel = null;
      if (state.day && state.cutoff) {
        const cutDate = new Date(cutoffMs(state.cutoff));
        if (!isNaN(cutDate.getTime())) {
          cutLabel = cutDate.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', timeZone: 'America/Los_Angeles' });
        }
      }
      $dayCutoff.innerHTML = cutLabel ? ('The order window closes at <strong>6 AM ' + cutLabel + '</strong>.') : 'The order window closes at <strong>6 AM the day before</strong> your pickup day.';
    }

    if (!$box) return; // pages without the box UI (home, PDP) just sync the nav count

    const full = $box.classList.contains('box-items--full');
    $box.innerHTML = '';
    if (!ids.length) {
      if ($empty) $empty.style.display = 'block';
    } else {
      if ($empty) $empty.style.display = 'none';
      ids.forEach((id) => {
        const it = catalog[id];
        const qty = state.box[id];
        const row = document.createElement('div');
        row.className = full ? 'box__row box__row--full' : 'box__row';
        const stepper =
          '<div class="stepper"><button class="js-dec" data-id="' + id + '" aria-label="one less ' + it.name + '">–</button>' +
          '<span>' + qty + '</span>' +
          '<button class="js-inc" data-id="' + id + '" aria-label="one more ' + it.name + '">+</button></div>';
        if (full) {
          const img = it.img ? '<a class="box__rowimg" href="' + it.url + '"><img src="' + it.img + '" alt="" loading="eager" decoding="async"></a>' : '<span class="box__rowimg box__rowimg--empty"></span>';
          const name = it.url ? '<a href="' + it.url + '">' + it.name + '</a>' : it.name;
          row.innerHTML =
            img +
            '<div class="box__rowmain"><div class="box__rowname">' + name + '</div>' +
            (it.sub ? '<div class="box__rowsub">' + it.sub + '</div>' : '') +
            '<div class="box__rowprice">' + money(it.price) + ' each</div></div>' +
            stepper +
            '<div class="box__rowtotal">' + money(it.price * qty) + '</div>' +
            '<button class="box__rowx js-remove" data-id="' + id + '" aria-label="Remove ' + it.name + '">×</button>';
        } else {
          row.innerHTML =
            '<div class="box__rowname">' + it.name + '</div>' +
            stepper +
            '<div class="box__rowprice">' + money(it.price * qty) + '</div>';
        }
        $box.appendChild(row);
      });
    }

    if ($subtotal) $subtotal.textContent = money(subtotal);

    if ($pickup) {
      if (state.day) {
        $pickup.textContent = 'Pickup: ' + state.day + ', 10 AM–1 PM';
        $pickup.classList.add('is-set');
      } else {
        $pickup.textContent = 'Choose a pickup day above';
        $pickup.classList.remove('is-set');
      }
    }

    const ready = c > 0 && state.day && state.first.trim() && state.last.trim();
    if ($reserve && !$reserve.disabled) {
      if ($reserve.hasAttribute('data-review')) {
        // Menu box: just collect items (+ pickup day); name/phone/checkout live on the cart page.
        $reserve.textContent = c === 0 ? 'Add something delicious' : 'Review my order · ' + money(subtotal);
        $reserve.classList.toggle('is-ready', c > 0);
      } else {
        $reserve.textContent = ready ? 'Check out · ' + money(subtotal) : (c === 0 ? 'Add something delicious' : (!state.day ? 'Pick a pickup day' : 'Add your name'));
        $reserve.classList.toggle('is-ready', !!ready);
      }
    }
    // Bakers' Box detection drives both the "you built a box" hint and the soft over-limit warning.
    const det = detectBoxes(state.box);
    const presentNames = det.present.map((p) => p.name);
    // Drop stale "clicked" flags for boxes no longer in the selection (so a later hand-build reads as accidental)
    Object.keys(state.clicked).forEach((n) => { if (presentNames.indexOf(n) === -1) delete state.clicked[n]; });
    // Soft cap: up to 4 individual items, OR exactly one Bakers' Box (a box can run 4–6 items).
    if ($boxhint) {
      if (det.present.length) {
        const lead = det.present[0].name;
        if (state.clicked[lead]) {
          $boxhint.innerHTML = 'Your <strong>' + lead + '</strong> is in your order. Nice choice.';
          $boxhint.classList.remove('box__boxhint--surprise');
        } else {
          $boxhint.innerHTML = 'Good eye. Your picks add up to our <strong>' + lead + '</strong>.';
          $boxhint.classList.add('box__boxhint--surprise');
        }
        $boxhint.hidden = false;
      } else {
        $boxhint.hidden = true;
        $boxhint.textContent = '';
        $boxhint.classList.remove('box__boxhint--surprise');
      }
    }
    updateScrollCue();
  }

  // Fade a peek of the next item while the box list can still scroll down
  function updateScrollCue() {
    if (!$scroll) return;
    const more = $scroll.scrollHeight - $scroll.clientHeight - $scroll.scrollTop > 4;
    $scroll.classList.toggle('can-scroll-down', more);
  }
  if ($scroll) $scroll.addEventListener('scroll', updateScrollCue, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(updateScrollCue); });

  document.addEventListener('click', (e) => {
    // preset "baker's box" — drops a whole combination in at once
    const combo = e.target.closest('.js-add-combo');
    if (combo) {
      resetReserve();
      let map = {};
      try { map = JSON.parse(combo.getAttribute('data-combo') || '{}'); } catch (err) { map = {}; }
      let added = 0;
      Object.keys(map).forEach((id) => { if (catalog[id] && mlAvailable(id)) { state.box[id] = (state.box[id] || 0) + map[id]; added += map[id]; } });
      if (combo.dataset.name) state.clicked[combo.dataset.name] = true; // they chose the box on purpose
      combo.classList.add('added');
      setTimeout(() => combo.classList.remove('added'), 500);
      render();
      announce('Added the ' + (combo.dataset.name || 'box') + ', ' + added + ' items. ' + totalCount() + ' in your order.');
      return;
    }
    const add = e.target.closest('.js-add');
    if (add) {
      const id = add.dataset.id;
      if (!mlAvailable(id)) { note(catalog[id] ? catalog[id].name + ' is sold out.' : 'That item is sold out.'); return; }
      resetReserve();
      state.box[id] = (state.box[id] || 0) + 1;
      add.classList.add('added');
      setTimeout(() => add.classList.remove('added'), 500);
      render();
      announce('Added ' + (catalog[id] ? catalog[id].name : 'item') + '. ' + totalCount() + ' in your order.');
      return;
    }
    const inc = e.target.closest('.js-inc');
    if (inc) { resetReserve(); state.box[inc.dataset.id]++; render(); return; }
    const dec = e.target.closest('.js-dec');
    if (dec) { resetReserve(); const id = dec.dataset.id; state.box[id] = Math.max(0, state.box[id] - 1); if (state.box[id] === 0) delete state.box[id]; render(); return; }
    const rem = e.target.closest('.js-remove');
    if (rem) { resetReserve(); delete state.box[rem.dataset.id]; render(); announce('Removed from your order. ' + totalCount() + ' left.'); return; }
    const day = e.target.closest('.js-day');
    if (day) {
      resetReserve();
      state.day = day.dataset.day;
      state.date = day.dataset.date || null;
      state.cutoff = day.dataset.cutoff || null;
      document.querySelectorAll('.js-day').forEach((d) => { const on = d === day; d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', String(on)); });
      render();
      return;
    }
  });

  // Pickup name (first + last) — required for checkout, persisted across pages
  const $first = document.querySelector('.js-pickup-first');
  const $last = document.querySelector('.js-pickup-last');
  if ($first) { $first.value = state.first || ''; $first.addEventListener('input', () => { state.first = $first.value; resetReserve(); saveState(); render(); }); }
  if ($last) { $last.value = state.last || ''; $last.addEventListener('input', () => { state.last = $last.value; resetReserve(); saveState(); render(); }); }
  const $phone = document.querySelector('.js-pickup-phone');
  if ($phone) { $phone.value = state.phone || ''; $phone.addEventListener('input', () => { state.phone = $phone.value; resetReserve(); saveState(); render(); }); }

  // ----- Box personality (shareable reveal on reserve) -----
  const CATS = {
    brioche:  { label: 'Brioche',  color: '#E19332' },
    focaccia: { label: 'Focaccia', color: '#52791C' },
    cookie:   { label: 'Cookies',  color: '#67214A' },
    cakelet:  { label: 'Cakelets', color: '#B0688A' },
    drink:    { label: 'Drinks',   color: '#0C412C' },
    beans:    { label: 'Beans',    color: '#4E1838' },
  };
  const PERSONAS = {
    brioche:  { title: 'Soft Spot',            copy: "You've got a soft spot, and it's shaped like a brioche bun." },
    focaccia: { title: 'The Focaccia Purist',  copy: 'Salt, crumb, and very good olive oil. No notes.' },
    cookie:   { title: 'The Cookie Connoisseur', copy: 'You tasted your way through the tin and chose well.' },
    cakelet:  { title: 'Small Cakes, Big Plans', copy: 'Little cakes, grand intentions. We respect it.' },
    drink:    { title: 'Iced to Meet You',     copy: 'Everything over ice, all year round. We admire the commitment.' },
    beans:    { title: 'The Home Barista',     copy: 'You take the ritual home. Bag by the grinder, kettle on.' },
    manifold: { title: 'The Manifold',         copy: 'A little of everything. You contain multitudes, and so does your box.' },
    twofold:  { title: 'Two-Fold',             copy: 'Two loves, one box. Balanced, exactly like you.' },
  };
  function personality() {
    const counts = {}; let total = 0;
    Object.keys(state.box).forEach((id) => {
      const q = state.box[id]; if (q <= 0) return;
      const cat = catalog[id] && catalog[id].cat; if (!cat || !CATS[cat]) return;
      counts[cat] = (counts[cat] || 0) + q; total += q;
    });
    if (!total) return null;
    const cats = Object.keys(counts).sort((a, b) => counts[b] - counts[a]);
    const top = cats[0];
    const maxShare = counts[top] / total;
    let key;
    if (maxShare >= 0.6) key = top;
    else if (cats.length >= 3) key = 'manifold';
    else key = 'twofold';
    const persona = PERSONAS[key] || PERSONAS[top];
    const breakdown = cats.map((c) => ({ cat: c, label: CATS[c].label, color: CATS[c].color, count: counts[c], pct: counts[c] / total }));
    return { title: persona.title, copy: persona.copy, breakdown: breakdown, total: total };
  }

  const $pcard = document.getElementById('pcard');
  let lastPersona = null, lastPickup = '';
  function openPcard(p, pickupText) {
    if (!$pcard || !p) return;
    lastPersona = p; lastPickup = pickupText;
    document.getElementById('pcard-title').textContent = p.title;
    document.getElementById('pcard-copy').textContent = p.copy;
    const bar = document.getElementById('pcard-bar');
    const legend = document.getElementById('pcard-legend');
    bar.innerHTML = ''; legend.innerHTML = '';
    p.breakdown.forEach((b) => {
      const seg = document.createElement('i');
      seg.style.width = (b.pct * 100).toFixed(2) + '%';
      seg.style.background = b.color;
      bar.appendChild(seg);
      const li = document.createElement('li');
      const dot = document.createElement('span');
      dot.className = 'dot'; dot.style.background = b.color;
      li.appendChild(dot);
      li.appendChild(document.createTextNode(b.count + ' ' + b.label));
      legend.appendChild(li);
    });
    document.getElementById('pcard-pickup').textContent = 'Pickup ' + pickupText;
    if (typeof $pcard.showModal === 'function') $pcard.showModal(); else $pcard.setAttribute('open', '');
  }
  // Render the card as a 1080x1920 Instagram-story PNG (self-contained, no libraries)
  function wrapLines(ctx, text, maxW) {
    const words = String(text).split(' '); const lines = []; let line = '';
    words.forEach((w) => { const t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line); return lines;
  }
  async function storyBlob(p, pickupText) {
    const W = 1080, H = 1920, cx = W / 2, pad = 140, cw = W - pad * 2;
    const BG = '#F7F2E8', PLUM = '#67214A', PLUMD = '#4E1838', INK = '#2C2028';
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');
    try {
      await Promise.all([
        document.fonts.load('500 130px "Fraunces"'),
        document.fonts.load('700 30px "Space Mono"'),
        document.fonts.load('400 46px "Nunito Sans"'),
      ]);
      await document.fonts.ready;
    } catch (e) { /* draw with fallbacks */ }
    ctx.fillStyle = BG; ctx.fillRect(0, 0, W, H);
    ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    let y = 330;
    const logo = document.querySelector('.pcard__logo');
    if (logo && logo.complete && logo.naturalWidth) {
      const lw = 430, lh = lw * (logo.naturalHeight / logo.naturalWidth);
      ctx.drawImage(logo, cx - lw / 2, y - lh, lw, lh);
    }
    y += 135;
    ctx.fillStyle = PLUM; ctx.font = '700 30px "Space Mono", monospace';
    ctx.fillText('WHAT YOUR WEEKEND LOOKS LIKE', cx, y);
    y += 120;
    ctx.fillStyle = PLUM; ctx.font = '500 132px "Fraunces", Georgia, serif';
    wrapLines(ctx, p.title, cw).forEach((line) => { ctx.fillText(line, cx, y); y += 138; });
    y += 24;
    ctx.fillStyle = INK; ctx.font = '400 46px "Nunito Sans", sans-serif';
    wrapLines(ctx, p.copy, cw - 40).forEach((line) => { ctx.fillText(line, cx, y); y += 62; });
    y += 66;
    const barH = 30;
    ctx.fillStyle = 'rgba(103,33,74,0.18)'; ctx.fillRect(pad, y, cw, barH);
    let bx = pad;
    p.breakdown.forEach((b) => { const w = b.pct * cw; ctx.fillStyle = b.color; ctx.fillRect(bx, y, w, barH); bx += w; });
    y += barH + 74;
    ctx.fillStyle = PLUM; ctx.font = '700 30px "Space Mono", monospace';
    const legItems = p.breakdown.map((b) => b.count + ' ' + b.label.toUpperCase());
    const legLines = [];
    for (var li = 0; li < legItems.length; li += 2) legLines.push(legItems.slice(li, li + 2).join('      '));
    legLines.forEach((line) => { ctx.fillText(line, cx, y); y += 48; });
    y += 46;
    ctx.fillStyle = PLUMD; ctx.font = '700 30px "Space Mono", monospace';
    ctx.fillText('PICKUP ' + String(pickupText).toUpperCase(), cx, y);
    y += 46;
    ctx.fillStyle = 'rgba(78,24,56,0.78)'; ctx.font = '700 26px "Space Mono", monospace';
    ctx.fillText('734 LINCOLN BLVD, VENICE', cx, y);
    ctx.fillStyle = 'rgba(103,33,74,0.60)'; ctx.font = '700 26px "Space Mono", monospace';
    ctx.fillText('MANIFOLDBAKERY.COM · @MANIFOLDBAKERY', cx, H - 150);
    return await new Promise((res) => cv.toBlob(res, 'image/png', 0.95));
  }

  if ($pcard) {
    document.getElementById('pcard-close').addEventListener('click', () => $pcard.close());
    $pcard.addEventListener('click', (e) => { if (e.target === $pcard) $pcard.close(); });
    // On close, native <dialog> restores focus to the (now-disabled) reserve button; move it to the confirmation instead
    $pcard.addEventListener('close', () => { if ($note) { $note.setAttribute('tabindex', '-1'); $note.focus(); } });
    const shareBtn = document.getElementById('pcard-share');
    shareBtn.addEventListener('click', async () => {
      if (!lastPersona) return;
      const label = shareBtn.textContent;
      shareBtn.textContent = 'Preparing…'; shareBtn.disabled = true;
      try {
        const blob = await storyBlob(lastPersona, lastPickup);
        const file = new File([blob], 'manifold-weekend.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try { await navigator.share({ files: [file], title: 'My Manifold weekend' }); }
          catch (e) { /* user cancelled the share sheet */ }
        } else {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a'); a.href = url; a.download = 'manifold-weekend.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1500);
          note('Story image saved. Open Instagram, add it to your story, and tag @manifold.');
        }
      } catch (e) {
        note('Could not build the image. Screenshot the card to share it.');
      } finally {
        shareBtn.textContent = label; shareBtn.disabled = false;
      }
    });
  }

  // Shared checkout: validate, then add the box to the real Shopify cart (pickup day/date
  // as order attributes) and send the guest to /checkout. Used by the box button AND the
  // persistent header CTA, so the checkout is always reachable without scrolling.
  let checkingOut = false;
  async function doCheckout() {
    if (checkingOut) return;
    const ids = Object.keys(state.box).filter((id) => state.box[id] > 0);
    if (!ids.length) { note('Add at least one item to your order to check out.'); focusEl('.js-add'); return; }
    if (!state.day) { note('Choose a pickup day above to check out.'); focusEl('.js-day'); return; }
    if (!state.first.trim() || !state.last.trim()) { note('Add the name for pickup to check out.'); focusEl(!state.first.trim() ? '.js-pickup-first' : '.js-pickup-last'); return; }
    // Final stale guard: never let a selection whose cutoff has passed go through to checkout.
    if (state.cutoff && Date.now() >= cutoffMs(state.cutoff)) {
      state.day = null; state.date = null; state.cutoff = null; saveState(); render();
      note('That pickup day just closed. Please choose another.'); focusEl('.js-day'); return;
    }
    const variants = window.ML_VARIANTS || {};
    const items = ids.map((id) => ({ id: variants[id], quantity: state.box[id] })).filter((i) => i.id);
    if (!items.length) { note('Sorry — checkout is temporarily unavailable for these items. Please try again shortly.'); return; }
    checkingOut = true;
    if ($reserve) { $reserve.disabled = true; $reserve.classList.remove('is-ready'); $reserve.textContent = 'Taking you to checkout…'; }
    const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    try {
      await fetch('/cart/clear.js', { method: 'POST', headers });
      const res = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
      if (!res.ok) {
        let amsg = '';
        try { const aerr = await res.json(); amsg = (aerr && (aerr.description || aerr.message)) || ''; } catch (e2) {}
        throw new Error(amsg || 'add failed');
      }
      // Record which Bakers' Box(es) this order forms, so it shows on the order whether the guest
      // clicked "Add box" or assembled the same items by hand.
      const det = detectBoxes(state.box);
      const boxLabel = det.present.length
        ? det.present.map((b) => {
            const base = b.copies > 1 ? b.name + ' x' + b.copies : b.name;
            return base + (state.clicked[b.name] ? ' (selected)' : ' (built from items)');
          }).join(', ')
        : 'None (individual items)';
      const pickupFirst = state.first.trim();
      const pickupLast = state.last.trim();
      await fetch('/cart/update.js', { method: 'POST', headers, body: JSON.stringify({ attributes: { 'Pickup name': (pickupFirst + ' ' + pickupLast).trim(), 'Pickup first name': pickupFirst, 'Pickup last name': pickupLast, 'Pickup phone': state.phone.trim(), 'Pickup day': state.day, 'Pickup date': state.date || '', 'Pickup window': '', "Baker's Box": boxLabel } }) });
      window.location.href = '/checkout';
    } catch (e) {
      checkingOut = false;
      if ($reserve) $reserve.disabled = false;
      render();
      note(e && e.message && e.message !== 'add failed' ? e.message + ' Please remove it and try again.' : 'Something went wrong reaching checkout. Please try again.');
    }
  }

  if ($reserve) {
    $reserve.addEventListener('click', () => {
      if ($reserve.disabled) return;
      if ($reserve.hasAttribute('data-review')) {
        if (!$reserve.classList.contains('is-ready')) return; // empty box → nothing to review yet
        var base = $reserve.getAttribute('data-review') || '/pages/cart';
        var pt = new URLSearchParams(location.search).get('preview_theme_id');
        window.location.href = pt ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(pt) : base;
        return;
      }
      doCheckout();
    });
  }

  // --- Sold-out / unavailable items: mark the card and block adding (uses ML_STOCK / ML_VARIANTS from ml-variants) ---
  function mlAvailable(id) {
    var v = window.ML_VARIANTS || {};
    var s = window.ML_STOCK || {};
    // Unavailable = no purchasable variant (draft / unpublished), or explicitly sold out (tracked + DENY, 0 on hand).
    return !!v[id] && s[id] !== 0;
  }
  function markSoldOut() {
    document.querySelectorAll('.item[data-id]').forEach(function (card) {
      var id = card.getAttribute('data-id');
      if (mlAvailable(id)) return;
      card.classList.add('item--soldout');
      var frame = card.querySelector('.item__frame');
      if (frame && !frame.querySelector('.item__soldout-badge')) {
        // Both badges stack in .item__badges (top-left). Create the container if an item isn't
        // seasonal (seasonal items ship it in markup), and put Sold Out FIRST so it sits above Seasonal.
        var badges = frame.querySelector('.item__badges');
        if (!badges) {
          badges = document.createElement('span');
          badges.className = 'item__badges';
          frame.insertBefore(badges, frame.firstChild);
        }
        var badge = document.createElement('span');
        badge.className = 'item__soldout-badge';
        badge.textContent = 'Sold out';
        badges.insertBefore(badge, badges.firstChild);
      }
      var btn = card.querySelector('.add');
      if (btn) { btn.classList.remove('js-add'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Sold out'; }
      if (state.box[id]) { delete state.box[id]; } // drop any restored sold-out item so checkout can't choke on it
    });
    document.querySelectorAll('.js-add-combo[data-combo]').forEach(function (btn) {
      var map = {};
      try { map = JSON.parse(btn.getAttribute('data-combo') || '{}'); } catch (e) { map = {}; }
      var out = Object.keys(map).some(function (id) { return !mlAvailable(id); });
      if (!out) return;
      btn.classList.remove('js-add-combo'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Sold out this weekend';
      var card = btn.closest('.setcard');
      if (card) card.classList.add('setcard--soldout');
    });
  }
  markSoldOut();
  render();
})();
